import axios from "axios";
import swal from "sweetalert";

import { InitPage } from "../../index";
import LiveClock from "../../controls/live_clock";
import ScreenSaver from "../../controls/screen_saver";

declare var $;
declare var App;
declare var monitorSubZone;
declare var storeLocation;
declare var mergeWithMasterTagInSubZone;
declare var soundAlertURL;
declare var viewOnly;
declare var undoMergeTagPath;
class ErcMasterTagDashboard {
  ercMasterTagMonitorChannel: any;
  missingAlertSound: any;

  constructor() {
    new LiveClock();
    new ScreenSaver();
    let _this = this;

    $(document).ready(function(){
      // $('.add-btn').on('click', function(e) {
      //   e.preventDefault();
      //   $('#manual-merge').modal('show');
      // });

      // $('.undo').on('click', function(e) {
      //   e.preventDefault();
      //   $('#manual-undo-merge').modal('show');
      // });

      $('.setting-icon').on('click', function(){
        $('.setting-modal').modal('show');
      });

      $('#zone').on('change', function() {
        window.location.href = window.location.pathname + `?zone=${$(this).val()}`
      })
      _this.missingAlertSound = new Audio(soundAlertURL);

      $('#submitToManualMerge').on('click', function(){
        _this.mergeDialog();
      })

      $('#submitToSearch').on('click', function(){
        _this.searchQuery();
      })

      $('#snFormMerge').on('submit', function(e) {
        e.preventDefault();
      })

      $('#snSearchForm').on('submit', function(e) {
        e.preventDefault();
      })

      if (localStorage.getItem('auto_add_master_tag_dashboard') == 't') {
        $('#auto_add').prop('checked', true);
      }

      $('#auto_add').on('change', function(e) {
        if ($('#auto_add').is(':checked')) {
          localStorage.setItem('auto_add_master_tag_dashboard', 't');
        } else {
          localStorage.removeItem('auto_add_master_tag_dashboard');
        }
      })

      $("#tag_number").keydown(function (e) {
        if (e.keyCode == 13) {
          if ($('#auto_add').is(':checked')) {
            _this.mergeDialog();
          }
        }
      });
    });
    const token = $("[name=authenticity_token]").val();
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
    // Connect ActionCable to receive reads
    this.ercMasterTagMonitorChannel = App.cable.subscriptions.create(
      // Connection configuration
      {
          channel: "ERC::MasterTag::MonitorChannel",
          tenant_code: `${storeLocation}`,
          zone: `${monitorSubZone}`
      },
      // Pass in connection callbacks
      {
          connected: () => { console.log('connect') },
          disconnected: () => { /* Called when the subscription has been terminated by the server */ },
          received: (data: any) => {
            console.log(data);
            $("#alert-Text").html(data.alert_in_html);
            $("#mergeDashboardMTTag").prepend(data.row_in_html);
            $("#transactions_today-number").text(data.tags_today);
            $("#merges_today-number").text(data.merges_today);
            $("#undo_merges_today-number").text(data.undo_merges_today);
            $("#last_5_minutes-number").text(data.last_5_minutes);
            if(viewOnly || !(data.merge_log)) {
              $(`#undo-actions-${data.log_id}`).html(`<a class="fa fa-undo fa-2x undo-icon undo disabled" rel="nofollow" onClick="return false;" disabled></a>`)
            } else {
              $(`#undo-actions-${data.log_id}`).html(`<a class="fa fa-undo fa-2x undo-icon undo" rel="nofollow" onClick="ercMasterTagDashboard.undoMergeDialog('${undoMergeTagPath}&id=${data.log_id}');return false;"></a>`)
            }
            _this.missingAlertSound.play();
          }
      }
    );
  }

  searchQuery() {
    let location = window.location.pathname;
    let query    = $('#query').val();
    window.location.href = location + `?zone=${monitorSubZone}&query=${query}`
  }

  submitForManualMerge() {
    console.log('this is happening');
    let tagNumber = $('#tag_number').val();
    let masterTagZone = $('#master_tag_zone').val();
    axios.post(mergeWithMasterTagInSubZone, { tag_number: tagNumber, master_tag_zone: masterTagZone}).then(function(response) {
      console.log(response.data);
      if(response.data.status == 'not_ok') {
        window.toastr_notifications.error(response.data.error)
      } else {
        window.toastr_notifications.success("Tag merged")
        $('#tag_number').val('')
      }
    }).catch(function(error) {
      console.log(error);
    });
  }

  undoMerge(url: string) {
    axios.post(url).then(function(response) {
      console.log(response.data);
      if(response.data.status == 'not_ok') {
        window.toastr_notifications.error(response.data.error)
      } else {
        window.toastr_notifications.success("Undo merge initiated")
      }
    }).catch(function(error) {
      console.log(error);
    });
  }

  mergeDialog() {
    swal({
      title: "Are you sure?",
      text: "You want to do this merge!",
      icon: "warning",
      buttons: {
        cancel: {
            text: "No",
            value: false,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-silver",
            closeModal: true
        },
        confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-danger",
            closeModal: true
        }
      },
      dangerMode: true
    }).then((isConfirmed) => {
      console.log(isConfirmed);
      if (isConfirmed) {
        this.submitForManualMerge();
      }
    });
  }

  undoMergeDialog(url: string) {
    swal({
      title: "Are you sure?",
      text: "You want to undo this merge!",
      icon: "warning",
      buttons: {
        cancel: {
            text: "No",
            value: false,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-silver",
            closeModal: true
        },
        confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-danger",
            closeModal: true
        }
      },
      dangerMode: true
    }).then((isConfirmed) => {
      console.log(isConfirmed);
      console.log(url);
      if (isConfirmed) {
        this.undoMerge(url);
      }
    });
  }
}

export function LoadPage() {
  InitPage("master_tag dashboard", () => {
    (window as any).ercMasterTagDashboard = new ErcMasterTagDashboard();
  });
}
